module.exports = __webpack_public_path__ + "static/media/5DPO2.2ce1bb43.jpg";